import { createStitches } from '@stitches/react';
import React, { useState } from 'react';

/* Palette: https://coolors.co/palette/22223b-4a4e69-9a8c98-c9ada7-f2e9e4 */
var _createStitches = createStitches({
    theme: {
      colors: {
        panelBackground: "#333",
        panelText: "#dcc",
        headings: "#F2E9E4"
      }
    }
  }),
  styled = _createStitches.styled,
  css = _createStitches.css,
  globalCss = _createStitches.globalCss;
var collapseChildren = css({
  "*:first-child": {
    marginTop: 0
  },
  "*:last-child": {
    marginBottom: 0
  }
});
var globalStyles = globalCss({
  "@import": ["https://rsms.me/inter/inter.css"],
  "*": {
    boxSizing: "border-box"
  },
  body: {
    margin: 0,
    padding: 0,
    height: "100%",
    width: "100%",
    overflow: "hidden",
    font: "14px/1.5 Inter, sans-serif"
  },
  "div#root": {
    width: "100vw",
    height: "100vh"
  }
});
globalStyles();

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

var BooleanControl = function BooleanControl(_ref) {
  var description = _ref.description,
    _onChange = _ref.onChange,
    _ref$checked = _ref.checked,
    initialChecked = _ref$checked === void 0 ? false : _ref$checked;
  var _useState = useState(initialChecked),
    _useState2 = _slicedToArray(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: checked,
    onChange: function onChange(e) {
      _onChange === null || _onChange === void 0 ? void 0 : _onChange(e.target.checked);
      setChecked(e.target.checked);
    }
  }), description && /*#__PURE__*/React.createElement(Description, null, description));
};
var Description = styled("span", {
  marginLeft: "0.25rem"
});

var Button = styled("button", {
  width: "100%",
  padding: "6px 8px 5px 8px",
  borderRadius: "5px",
  boxShadow: "1px 1px 1px 0 rgba(0, 0, 0, 0.1), inset 1px 1px 0 0 rgba(255, 255, 255, 0.1)",
  border: "1px solid rgba(0, 0, 0, 0.8)",
  borderWidth: "1px 1px 3px 1px",
  outline: "none",
  font: "inherit",
  backgroundColor: "#555",
  color: "rgba(255, 255, 255, 0.7)",
  cursor: "pointer",
  textShadow: "rgba(0, 0, 0, 0.2) 1px 2px 1px",
  "&:hover": {
    backgroundColor: "#666"
  },
  "&:active": {
    borderWidth: "2px 0 2px 2px"
  }
});

var Heading = styled("h3", {
  font: "inherit",
  fontWeight: "bold",
  textShadow: "rgba(0, 0, 0, 0.5) 2px 2px 1px",
  color: "$headings",
  margin: "1.5rem 0 0.5rem 0"
});

var HorizontalGroup = styled("div", {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  variants: {
    align: {
      start: {
        alignItems: "flex-start"
      },
      center: {
        alignItems: "center"
      },
      end: {
        alignItems: "flex-end"
      }
    },
    gap: {
      "true": {
        gap: "0.25rem"
      }
    }
  }
});

var HorizontalResizer = function HorizontalResizer() {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2);
    _React$useState2[0];
    var setDragging = _React$useState2[1];
  var handleMouseDown = React.useCallback(function () {
    setDragging(true);
  }, []);
  var handleMouseUp = React.useCallback(function () {
    setDragging(false);
  }, []);
  return /*#__PURE__*/React.createElement(HorizontalResizerDiv, {
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp
  });
};
var HorizontalResizerDiv = styled("div", {
  backgroundColor: "#000",
  transition: "background-color 0.15s",
  width: 5,
  cursor: "col-resize",
  "&:hover": {
    backgroundColor: "hotpink"
  }
});

var Input = styled("input", {
  font: "inherit",
  color: "inherit",
  backgroundColor: "inherit",
  border: "0",
  background: "#222",
  padding: "5px 8px",
  outline: "none",
  caretColor: "hotpink",
  borderRadius: "5px",
  boxShadow: "inset 1px 1px 2px 0 rgba(0, 0, 0, 0.5), inset -1px -1px 2px 0 rgba(255, 255, 255, 0.2)",
  "&::selection": {
    backgroundColor: "hotpink",
    color: "white"
  },
  width: "100%"
});

var Root = styled("div", {
  font: "14px/1.5 Inter, sans-serif",
  backgroundColor: "#111",
  width: "100%",
  height: "100%",
  display: "flex",
  userSelect: "none"
});

var VerticalGroup = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: 4,
  padding: 4
});

var Panel = styled("div", collapseChildren, {
  backgroundColor: "$panelBackground",
  borderRadius: 5,
  color: "$panelText",
  textShadow: "rgba(0, 0, 0, 0.2) 1px 2px 1px",
  padding: "1rem"
});
var Control = styled("div", {
  display: "flex",
  alignItems: "center",
  minHeight: "2rem",
  margin: "0.25rem 0"
});
var Label = styled("div", {
  flex: "0 0 30%"
});

export { BooleanControl, Button, Control, Heading, HorizontalGroup, HorizontalResizer, Input, Label, Panel, Root, VerticalGroup };
